import axios from 'axios';

const state = {
    birthdays: [],
    templates: [],
    settings: null,
    stats: null,
    logs: []
};

const getters = {

};

const actions = {
    // Birthday List
    birthday_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('birthdays', { params: data })
                .then(response => {
                    commit("PUSH_BIRTHDAYS", response.data.data.birthdays);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_send({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post(`birthdays/send/${data.contact_id}`, data)
                .then(response => {
                    commit("PUSH_BIRTHDAYS", response.data.data.birthdays);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_retry_failed({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('birthdays/retry-failed', data)
                .then(response => {
                    commit("PUSH_BIRTHDAYS", response.data.data.birthdays);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Templates
    birthday_template_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('birthday-templates', { params: data })
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('birthday-templates', data)
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_one({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`birthday-templates/${id}`)
                .then(response => {
                    commit("PUSH_TEMPLATE", response.data.data.template);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            const { id, ...updateData } = data;
            axios.put(`birthday-templates/${id}`, updateData)
                .then(response => {
                    commit("PUSH_TEMPLATE", response.data.data.template);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`birthday-templates/${id}`)
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_set_default({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.patch(`birthday-templates/${id}/default`)
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_template_preview({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('birthday-templates/preview', data)
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Settings
    birthday_settings_get({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('birthday-settings')
                .then(response => {
                    commit("SET_SETTINGS", response.data.data.setting);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_settings_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('birthday-settings', data)
                .then(response => {
                    commit("PUSH_SETTINGS", response.data.data.setting);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Statistics & Logs
    birthday_stats({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('birthday-stats', { params: data })
                .then(response => {
                    commit("SET_STATS", response.data.data.stats);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_logs({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('birthday-logs', { params: data })
                .then(response => {
                    commit("PUSH_LOGS", response.data.data.logs);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_logs_export(context, data) {
        return new Promise((resolve, reject) => {
            axios.get('birthday-logs/export', { params: data, responseType: 'blob' })
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Import
    birthday_import({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('birthdays/import', data)
                .then(response => {
                    commit("PUSH_BIRTHDAYS", response.data.data.birthdays);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    birthday_import_history({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('birthdays/import-history')
                .then(response => {
                    commit("PUSH_LOGS", response.data.data.logs);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    PUSH_BIRTHDAYS(state, birthdays) {
        state.birthdays = birthdays;
    },
    PUSH_TEMPLATES(state, templates) {
        state.templates = templates;
    },
    SET_SETTINGS(state, settings) {
        state.settings = settings;
    },
    SET_STATS(state, stats) {
        state.stats = stats;
    },
    PUSH_LOGS(state, logs) {
        state.logs = logs;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

